import axios from "axios";
import Cookies from "js-cookie";

export const axiosInstance = axios.create({
    baseURL: process.env.REACT_APP_BACKEND_URL,
});

// Add a request interceptor
axiosInstance.interceptors.request.use(
    (config) => {
        const uName = Cookies.get('user') || 'NoUser';
        const dbName = Cookies.get('database')|| 'M2026' ;
        
        // Ensure headers object exists
        config.headers = config.headers || {};

        if (dbName) {
            config.headers["x-db"] = dbName;
        } else {
            // Optional: Log or handle cases where DB is required but missing
            console.warn("Database context missing for request:", config.url);
        }
        if (uName) {
            config.headers["X-User-Name"] = uName;
        } else {
            console.warn("User context missing for request:", config.url);
        }

        return config;
    },
    (error) => {
        return Promise.reject(error);
    }
);